import { Plugin, PluginKey } from '@tiptap/pm/state';

/**
 * Find the closest anchor element from the event target.
 * This handles cases where the click might be on a child of the anchor,
 * such as when bold text contains a link.
 */
export const findAnchorElement = (element: EventTarget | null): HTMLAnchorElement | null => {
    if (!element || !(element instanceof Element)) return null;
    return element.closest('a') as HTMLAnchorElement | null;
};

export function linkClickHandler(clickableLinksWhenEditable: boolean): Plugin {
    return new Plugin({
        key: new PluginKey('linkClickHandler'),
        props: {
            handleDOMEvents: {
                click(view, event) {
                    const link = findAnchorElement(event.target);
                    if (!link) return;

                    // Prevent click events when tapping an anchor.
                    // The click handler below will still run (it's actually listening to
                    // mouseUp under the hood), but this will stop any other handlers from
                    // running (eg selecting the element or starting to edit it).
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                },
            },
            handleClick: (view, pos, event) => {
                if (event.button !== 0) return false;

                if (view.editable && !clickableLinksWhenEditable) return false;

                const link = findAnchorElement(event.target);
                if (!link?.href) return false;

                window.open(link.href, '_blank');
                return true;
            },
        },
    });
}
